import React from "react";
import {Page, Text, View, Document, StyleSheet, Font} from "@react-pdf/renderer";
import OpenSansRegular from "../../../../../statics/typos/openSansRegular.ttf";
import OpenSansSemiBold from "../../../../../statics/typos/openSansSemiBold.ttf";
import OpenSansBold from "../../../../../statics/typos/openSansBold.ttf";
import {TrailerOrContainerOrderFileModel} from "../../../../models/order";
import {OrderFilesUtils} from "../../../../../helpers/orderFilesUtils";
import {DateUtils} from "../../../../../helpers/dateUtils";
import {Utils} from "../../../../../helpers/utils";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSansRegular
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold
});

const styles = StyleSheet.create(OrderFilesUtils.styles);

interface ExportOrderTrailerOrContainerFileProps {
    order: TrailerOrContainerOrderFileModel | null | undefined,
    username: string
}

export default function ExportOrderTrailerOrContainerFile(props: ExportOrderTrailerOrContainerFileProps): React.ReactElement {
    if (!props.order) {
        return <Document><Page/></Document>;
    }

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    {OrderFilesUtils.renderHeader("ZLECENIE ZŁOŻENIA NACZEPA/KONTENER W EKSPORCIE \n " +
                        "EXPORT ORDER TRAILER/CONTAINER")}
                    {renderTable()}
                </View>
            </Page>
        </Document>
    );

    function renderTable() {
        return (
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderOrderType(props.order!.relationType)}
                    {OrderFilesUtils.renderOrderNo(props.order!.orderId)}
                    {OrderFilesUtils.renderBookingNo(props.order!.bookingNo)}
                    {OrderFilesUtils.renderVoyageNo(props.order!.voyageNo)}
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderCargoType(props.order!.cargoType)}
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Nr identyfikacyjny /{"\n"}
                            Identification no
                        </Text>
                        <Text style={styles.tableCellData}>
                            {OrderFilesUtils.renderMeansOfTransportNo({
                                trailerRegNo: props.order!.trailerRegNo,
                                containerNo: props.order!.containerNo
                            })}
                        </Text>
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Rezerwacja/godz. /{"\n"}
                            Reservation/hour
                        </Text>
                        <Text style={styles.tableCellData}>
                            {DateUtils.getFormattedDateWithTime(props.order!.createdAt)}
                        </Text>
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.renderFerry(props.order!.ferryName)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.renderCargoWeight(props.order!.weight)}
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.renderDangerousGoods(props.order!.isDangerousGoods)}
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.requestedTemp(props.order!.requestedTemp1, 1)}
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.requestedTemp(props.order!.requestedTemp2, 2)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableBigCol}>
                        {OrderFilesUtils.renderTransportCompany(props.order!.transportCompany)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Złożenie /{"\n"}
                            Submission
                        </Text>
                        <Text style={styles.tableCellData}>
                            {OrderFilesUtils.renderTransportType(props.order!.relationType)}
                        </Text>
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Nr identyfikacyjny /{"\n"}
                            Identification no
                        </Text>
                        <Text style={styles.tableCellData}>
                            {OrderFilesUtils.renderMeansOfTransportNo({
                                lorryRegNo: props.order!.lorryRegNo,
                                wagonRegNo: props.order!.wagonRegNo
                            })}
                        </Text>
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Deklaracja sztauowania i mocnowania ładunku /{"\n"}
                            Securing declaration
                        </Text>
                        <Text style={styles.tableCellData}>
                            {Utils.renderBooleanYesNoValue(props.order!.securingDeclaration, false)}
                        </Text>
                    </View>
                    {OrderFilesUtils.renderPinCode(props.order!.pinCode)}
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderTimeOfDepositingLoad(props.order!.timeOfDepositingLoad)}
                    {OrderFilesUtils.renderFreeTimeFromFees(props.order!.freeTimeFromFees)}
                    <View style={styles.tableSmallCol}>
                        <Text style={styles.tableCellHeader}>
                            Data zaokrętowania/godz. /{"\n"}
                            Embarkation date
                        </Text>
                        <Text style={styles.tableCellData}>
                            {DateUtils.getFormattedDateWithTime(props.order!.arrivalDepartureTime)}
                        </Text>
                    </View>
                    <View style={styles.tableSmallCol}>
                        {OrderFilesUtils.renderStorageTime(props.order!.storageTime)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderPaymentMethod(props.order!.paymentMethod)}
                    {OrderFilesUtils.renderPaymentDocumentNumber(props.order!.paymentDocumentNumber)}
                </View>
                {OrderFilesUtils.renderRemarks(props.order!.remarks)}
                {OrderFilesUtils.requestedSignatures(false, props.username)}
            </View>
        );
    }
}

